import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { labourOfficialWorkApi } from '../api/labourOfficialWorkApi'; 
import { RootState } from '..';

export interface LabourOfficialWorkState {
  labourOfficialWorkDetails: any;
  loading: boolean;
  error: string | null;
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: LabourOfficialWorkState = {
  labourOfficialWorkDetails: null,
  loading: false,
  error: null,
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

const labourOfficialWorkSlice = createSlice({
  name: 'labourOfficialWork',
  initialState,
  reducers: {
    setOfficialWorkDetails: (state, action: PayloadAction<any>) => {
      state.labourOfficialWorkDetails = action.payload;
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        labourOfficialWorkApi.endpoints.createLabourOfficialWork.matchPending,
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        labourOfficialWorkApi.endpoints.createLabourOfficialWork.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.labourOfficialWorkDetails = action.payload;
          state.error = null;
        }
      )
      .addMatcher(
        labourOfficialWorkApi.endpoints.createLabourOfficialWork.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message || 'Something went wrong';
        }
      );
  },
});

// Action creators are generated for each case reducer function
export const { setOfficialWorkDetails, setLoading, setError, reset } = labourOfficialWorkSlice.actions;
export const getOfficialWorkDetails = (state: RootState) => state.labour.data;
export const getOfficialWorkDetailsTotalRecords = (state: RootState) => state.labour.totalRecords;

export default labourOfficialWorkSlice.reducer;